import {
    IRecordTypeFeatureInfoClick,
    MapListRecordItem,    

    IMappingTextPack
} from "@esdm/map";


export class SuffolkMapListRecordItem extends MapListRecordItem {       

    public constructor(
        mappingTextPack: IMappingTextPack
    ) {
        super(mappingTextPack);
    }

    //public getHtml = (feature: IRecordTypeFeatureInfoClick): string => {
    //    let layerType: string = feature.layerGroup.layerType;
    //    let html = `
    //                 <li>
    //                    <a href="/${this.controller(feature)}/[uid]" title="${this._mappingTextPack.goToDetails}"><span><i class="far fa-info-circle" aria-hidden="true"></i></span></a>
    //                    &nbsp;
    //                    <a href="/${this.controller(feature)}/[uid]" title="${this._mappingTextPack.goToDetails}">                               
    //                        <span>[name]</span>               
    //                    </a>
    //                    <a class="showOnMap" title="${this._mappingTextPack.centreOnMap}" data-recordtype="${layerType}" data-id="[uid]">                                                
    //                        <i class="far fa-map-marked-alt fa-lg" aria-hidden="true"></i>
    //                    </a>
    //                 </li>`;

    //    //feature.data.id = feature.getId();
    //    return this.replaceTokens(html, feature.data);
    //}

    //protected replaceTokens = (html, data): string => {
    //    //go thru html string and replace any tokens with attribute values
    //    for (var attributeName in data) {
    //        if (data.hasOwnProperty(attributeName)) {
    //            html = html.replace(new RegExp("\\[" + attributeName + "\\]", "g"), data[attributeName]);
    //        }
    //    }
    //    return html;
    //}

    //private controller = (feature: IRecordTypeFeatureInfoClick): string => {
    //    let val: string = "";

    //    switch (feature.recordType.toLowerCase()) {
    //        case "mon":
    //            val = "Monument";
    //            break;
    //        case "event":
    //            val = "Event";
    //            break;
    //        case "desig":
    //            val = "Designation";
    //        case "cons":
    //            val = "Consultation";
    //            break;
    //    }
    //    return val;
    //}

}